import { Accordion } from '@/components/common/Accordion';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import AssignModifications from '@/components/dashboard/practitioners/assigning-modifications/AssignModifications';
import Clinics from '@/components/dashboard/practitioners/clinics/Clinics';
import InvitePractitioner from '@/components/dashboard/practitioners/InvitePractitioner';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const PractitionersPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const [accordionValue, setAccordionValue] = useState('');

  return (
    <div className="px-0 py-12.5 md:px-4">
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          className="w-full space-y-4 border-none"
          value={accordionValue}
          onValueChange={setAccordionValue}
        >
          <InvitePractitioner />

          <Clinics />

          <AssignModifications accordionOpenValue={accordionValue} />
        </Accordion>
      </CardsContainer>
    </div>
  );
};
